const posts = [
  {
    title: "Behind the Seams",
    description: "How we source sustainable denim.",
    date: new Date(),
    user: "Admin",
  },
  {
    title: "Fit Guide",
    description: "Finding the perfect jeans for your body type.",
    date: new Date(),
    user: "Admin",
  },
  {
    title: "Indore Inspirations",
    description: "How our city influences our designs.",
    date: new Date(),
    user: "Admin",
  },
  {
    title: "Denim Care 101",
    description: "Tips to make your jeans last longer",
    date: new Date(),
    user: "Admin",
  },
  {
    title: "New Collection Teaser",
    description: "Sneak peek of upcoming launches.",
    date: new Date(),
    user: "Admin",
  },
];

export { posts };
